(function (window, document) {
  if (window.initTransformationStats) return

  window.initTransformationStats = function initTransformationStats(root) {
    const scope = root && root.querySelectorAll ? root : document
    const containers = []

    if (root && root.matches && root.matches('[data-transformation-stats]')) {
      containers.push(root)
    }

    scope.querySelectorAll('[data-transformation-stats]').forEach((container) => {
      if (!containers.includes(container)) containers.push(container)
    })

    containers.forEach((container) => {
      if (container.__ctrStatsObserver) {
        container.__ctrStatsObserver.disconnect()
      }

      container.querySelectorAll('.ctr-transformation-stats__bar').forEach((bar) => {
        bar.classList.remove('m-animated')
      })

      const bars = container.querySelectorAll('[data-animate-bar]')
      let hasAnimated = false

      const animateBars = () => {
        if (hasAnimated) return
        hasAnimated = true

        bars.forEach((wrapper, index) => {
          const bar = wrapper.querySelector('.ctr-transformation-stats__bar')
          if (!bar) return
          bar.classList.remove('m-animated')
          void bar.offsetWidth
          window.setTimeout(() => {
            bar.classList.add('m-animated')
          }, index * 150)
        })
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animateBars()
              observer.disconnect()
            }
          })
        },
        { threshold: 0.1 },
      )

      container.__ctrStatsObserver = observer

      const rect = container.getBoundingClientRect()
      const inView = rect.top < window.innerHeight && rect.bottom > 0
      if (inView) {
        animateBars()
      } else {
        observer.observe(container)
      }
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.initTransformationStats(document))
  } else {
    window.initTransformationStats(document)
  }
})(window, document)
